// pl_pms_reports.ts
// Tłumaczenia dla PMS.Reports – Live snapshot raportów operacyjnych

export const plPmsReports = {

  title: "Raporty",
  subtitle: "Raport operacyjny na żywo z systemu PMS.",

  // ── Wskaźniki ─────────────────────────────────────────────────────────────
  metrics: {
    occupancy:        "Obłożenie",
    reservations:     "Rezerwacje",
    checkedIn:        "Zameldowani",
    checkedOut:       "Wymeldowani",
    currentProperty:  "Bieżący obiekt",
    liveStatus:       "Status na żywo",
  },

  // ── Tabela główna ─────────────────────────────────────────────────────────
  primary: {
    title:              "Wyniki operacyjne",
    subtitle:           "Bieżąca aktywność hotelu.",
    arrivalsToday:      "Przyjazdów dziś",
    departuresToday:    "Odjazdów dziś",
    totalCharges:       "Łącznie należności",
    totalPayments:      "Łącznie płatności",
    outstandingBalance: "Saldo do zapłaty",
  },

  // ── Tabela segmentów rynku ────────────────────────────────────────────────
  marketSegment: {
    title:            "Mix segmentów rynku",
    subtitle:         "Rezerwacje wg segmentu rynku.",
    emptyLabel:       "Segmenty rynku",
    emptyValue:       "Brak danych",
    reservationCount: "{{count}} rezerwacja(e)",
  },

  // ── Tabela źródeł i pickup ────────────────────────────────────────────────
  sourcePickup: {
    title:              "Produkcja źródeł",
    subtitle:           "Rezerwacje wg źródła/kanału.",
    emptySourceLabel:   "Produkcja źródeł",
    emptySourceValue:   "Brak danych",
    reservationCount:   "{{count}} rezerwacja(e)",
  },

  pickup: {
    title:      "Pickup (7 dni)",
    subtitle:   "Rezerwacje utworzone dziennie w ostatnich 7 dniach.",
    emptyValue: "Brak danych",
  },

  meta: {
    generatedAt: "Wygenerowano",
  },

} as const;

export default plPmsReports;
